import React from "react";
import PropTypes from "prop-types";

import { Button } from "@material-ui/core";

import "./SignaturePad.css";

import ReactSignaturePad from "react-signature-pad-wrapper";

let signaturePad;

const SignaturePad = (props) => (
  <div className="react-signature-pad">
    <ReactSignaturePad
      ref={(ref) => (signaturePad = ref)}
      redrawOnResize={true}
      options={{
        onEnd: () => props.onChange(signaturePad.toDataURL()),
      }}
    />
    <Button
      color="primary"
      onClick={() => {
        signaturePad.clear();
        props.onChange("");
      }}
    >
      Clear
    </Button>
  </div>
);

SignaturePad.propTypes = {
  onChange: PropTypes.func.isRequired,
};

export default SignaturePad;



// WEBPACK FOOTER //
// ./src/components/SignaturePad.js